import type { AlternateQuotationPricing } from '../../utils/quotationUnitConversions';

export type LbOrInner =
  | { kind: 'inner'; value: number }
  | { kind: 'lb'; value: number }
  | { kind: 'none' };

/**
 * D104.11: what the grid's "Equiv. per lb / inner" cell states - the inner when the line has one,
 * else per lb, else blank. Which figures exist is decided by `getAlternateQuotationPricing`
 * (an inner is only ever a piece no bigger than the line's unit); this only chooses between them.
 */
export function perLbOrInner(alt: AlternateQuotationPricing): LbOrInner {
  if (alt.perInnerUsd != null && alt.perInnerUsd > 0) return { kind: 'inner', value: alt.perInnerUsd };
  if (alt.perLbUsd != null && alt.perLbUsd > 0) return { kind: 'lb', value: alt.perLbUsd };
  return { kind: 'none' };
}
